// extracted by mini-css-extract-plugin
export var brand = "_4v-9";
export var compact = "_4v-6";
export var extraSmall = "_4v-7";
export var icon = "_4v-0";
export var large = "_4v-4";
export var light = "_4v-1";
export var medium = "_4v-5";
export var outline = "_4v-b";
export var primaryDark = "_4v-a";
export var primaryLight = "_4v-8";
export var primaryModern = "_4v-c";
export var success = "_4v-2";
export var successSolid = "_4v-3";